import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import DocumentsUploadTransitionsContainer from './DocumentsUploadTransitionsContainer';
import { Dialog } from '@totalsoft/rocket-ui';
import { BackdropCustom, DialogButton, DialogTitle } from './DocumentsStyles';

const DocumentsUploadTransitionsModal = ({ onCloseDocumentUploadTransitionsModal, documentAttachmentId, t }) => {
  return (
    <Dialog
      id='doc-attachment-stateTransitions-dialog'
      open={true}
      onClose={onCloseDocumentUploadTransitionsModal}
      fullWidth
      maxWidth={'md'}
      BackdropComponent={BackdropCustom}
      transitionDuration={0}
      showX={false}
      disableBackdropClick
      disableEscapeKeyDown
      actionsProps={{ sx: theme => ({ px: theme.spacing(3), pb: theme.spacing(2) }) }}
      title={<DialogTitle>{t('OfferEdit.Documents.Transitions.Title')}</DialogTitle>}
      content={
        <>
          <Dialog
            showX={false}
            disableBackdropClick
            disableEscapeKeyDown
            actionsProps={{ sx: theme => ({ px: theme.spacing(3), pb: theme.spacing(2) }) }}
            title={t('OfferEdit.Documents.Transitions.Title')}
            actions={
              <DialogButton
                id={'doc_attachment_stateTransitions_cancelBtn'}
                color='primary'
                variant='contained'
                onClick={onCloseDocumentUploadTransitionsModal}
              >
                {t('OfferEdit.Subsidies.ConfirmationDialog.CancelButton')}
              </DialogButton>
            }
          />
          <DocumentsUploadTransitionsContainer documentAttachmentId={documentAttachmentId} />
        </>
      }
      actions={
        <DialogButton
          id={'doc_attachment_stateTransitions_closeBtn'}
          color='primary'
          variant='contained'
          onClick={onCloseDocumentUploadTransitionsModal}
        >
          {t('Close')}
        </DialogButton>
      }
    />
  );
};

DocumentsUploadTransitionsModal.propTypes = {
  onCloseDocumentUploadHistoryModal: PropTypes.func.isRequired,
  documentAttachmentId: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
  onCloseDocumentUploadTransitionsModal: PropTypes.func.isRequired
};
export default compose(withTranslation())(DocumentsUploadTransitionsModal);
